export enum PartnershipSettingsTabType {
  SHARING_SETTINGS = 'sharing-settings',
  SHARED_WITH_YOU = 'shared-with-you',
  TEAM_ACCESS = 'team-access',
}
